import React from 'react'
import { useNavigate } from 'react-router'

function App() {
  const navigate = useNavigate()

  return (
    <footer className="site-footer">
      <div className="container">
        <div
          className="row"
          style={{ justifyContent: 'space-between', width: '100%' }}
        >
          <div className="col-6 col-md-4 col-lg-3">
            <h6>Navigation</h6>
            <ul className="footer-links">
              <li>
                <a href="http://swara.video">Home</a>
              </li>
              {/* <li>
                <a target="_blank" href="http://swara.media">
                  FAQ
                </a>
              </li>
              <li>
                <a target="_blank" href="http://swara.media">
                  Investor Relations
                </a>
              </li>
              <li>
                <a target="_blank" href="http://swara.media">
                  Jobs
                </a>
              </li> */}
              <li>
                <a
                  target="_blank"
                  onClick={() => navigate('/about-us')}
                  className="footer-item"
                >
                  About Us
                </a>
              </li>
            </ul>
          </div>
          <div className="col-6 col-md-4 col-lg-3">
            <h6>LEGAL</h6>
            <ul className="footer-links">
              <li>
                <a
                  target="_blank"
                  onClick={() => navigate('/privacy-policy')}
                  className="footer-item"
                >
                  Privacy Policy
                </a>
              </li>
              {/* <li>
                <a target="_blank" href="http://swara.media">
                  Terms of Service
                </a>
              </li> */}

              {/* <li>
                <a target="_blank" href="http://swara.media">
                  Corporate Information
                </a>
              </li> */}
            </ul>
          </div>
          <div className="col-6 col-md-4 col-lg-3">
            <h6>TALK TO US</h6>
            <ul className="footer-links">
              <li>
                <a target="_blank" href="mailto:hello@swara.media">
                  hello@swara.media
                </a>
              </li>
              <li>
                <a target="_blank" href="tel:+19876547865">
                  +1- (530) 444 - 9125
                </a>
              </li>
            </ul>
          </div>

          <div className="col-6 col-md-4 col-lg-3">
            <h6>FOLLOW US</h6>
            <div className="social-icons-container">
              <a target="_blank" href="https://www.facebook.com/TheSwaraMedia/">
                <img
                  className="social-icon"
                  src="https://cdn-icons-png.flaticon.com/512/124/124010.png"
                />
              </a>
              <a
                target="_blank"
                href="https://www.instagram.com/TheSwaraMedia/"
              >
                <img
                  className="social-icon"
                  src="https://cdn-icons-png.flaticon.com/512/174/174855.png"
                />
              </a>
              <a
                target="_blank"
                href="https://www.linkedin.com/company/theswaramedia/"
              >
                <img
                  className="social-icon"
                  src="https://cdn-icons-png.flaticon.com/512/3536/3536505.png"
                />
              </a>
              <a target="_blank" href="https://twitter.com/TheSwaraMedia">
                <img
                  className="social-icon"
                  src="https://cdn-icons-png.flaticon.com/512/733/733579.png"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="copyright-container">
        <p className="copyright-text">
          Copyright &copy; 2023 All Rights Reserved.
        </p>
      </div>
    </footer>
  )
}

export default App
